import { GraphQLErrors, isApolloError } from '@apollo/client/errors';
import capitalize from 'capitalize';

import { Toast } from '../components/Toast';

function showErrorToUser<ErrorType extends { message: string }>(
	error: ErrorType,
	options = { title: 'Error' },
) {
	if (!('message' in error)) {
		return;
	}

	return Toast.show({
		type: 'error',
		text1: options.title,
		text2: error.message,
	});
}

function getGraphQlErrorMessage(errors: GraphQLErrors) {
	const message = errors.reduce((mergedMessage, { extensions, message }) => {
		if (message) {
			return mergedMessage.concat(`${message}\n`);
		}

		if (extensions?.code === 'BAD_USER_INPUT') {
			const { response, exception } = extensions as {
				response?: { message: string | string[] };
				exception?: { stacktrace: string[] };
			};

			if (exception) {
				console.error(exception.stacktrace);

				return mergedMessage;
			}

			if (!response) {
				return mergedMessage;
			}

			if (!Array.isArray(response.message)) {
				return mergedMessage.concat(`${response.message}\n`);
			}

			const mergedErrorMessages = response.message.map((message) => capitalize(message)).join('\n');

			return mergedMessage.concat(`${mergedErrorMessages}\n`);
		}

		return mergedMessage;
	}, '');

	return message.trim();
}

function showApolloErrorToUser(error: Error, options = { title: 'Error' }) {
	if (isApolloError(error)) {
		const message = getGraphQlErrorMessage(error.graphQLErrors);
		showErrorToUser({ message: message || String(error) }, options);
	}
}

export { showErrorToUser, showApolloErrorToUser };
